module.exports.gridClasses = {
  container: "container",
  row: "row justify-content-center",
  rowLeft: "row",
  col: "col",
  withoutSidebar: "col col-12 col-md-12 col-lg-6",
  halfWithoutSidebar: "col col-12 col-sm-6 col-md-6 col-lg-3",
  half: "col col-12 col-md-6 col-lg-4",
  halfSolo: "col offset-lg-2 col-12 col-md-6 col-lg-4",
  full: "col col-12 col-md-12 col-lg-8"
};
